import { DynamicValue } from "@faedev/dynamic-values";
import { composeClassNames } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import { CSSProperties } from "react";
import { Form } from "react-bootstrap";
import MqGteTablet from "src/components/MqGteTablet";
import constants from "src/constants";
import translate from "src/functions/translate";
import Sort from "src/icons/Sort";
import { sCustomSelect } from "src/styles/sCustomSelect.module.scss";
import { sListHeaderLabel } from "src/styles/sListHeaderLabel.module.scss";
import { sSort } from "src/styles/sSort.module.scss";
import { TypeSelectOption } from "src/types/TypeSelectOption";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
  value: DynamicValue<string>;
  data: TypeSelectOption[];
};

function Sort1({ style, className, value, data }: Props) {
  const { locale: lang } = useRouter();
  return (
    <div
      className={composeClassNames([sSort, className, "sort"])}
      style={style}
    >
      <Form.Label
        className={composeClassNames([sListHeaderLabel, "sort-label"])}
      >
        <MqGteTablet>
          <Sort size={constants.Icon.md} />
        </MqGteTablet>
        {translate(`Sort`, lang)}:
      </Form.Label>
      <Form.Control
        as={`select`}
        size={`sm`}
        className={composeClassNames([sCustomSelect, "sort-select"])}
        custom={true}
        value={value?.value}
        onChange={(e) => {
          value.change(e.target.value);
        }}
      >
        {data.map(({ title, value }) => (
          <option key={value} value={value}>
            {translate(title, lang)}
          </option>
        ))}
      </Form.Control>
    </div>
  );
}

export default Sort1;
